import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'

const HTTP = axiosConfig.HTTP

const state = {
  code: '',
  loading: false,
  error: false,
  errorDescription: '',
  totalRegistros: 0
}

// getters
const getters = {
}

// actions
const actions = {
  async getVendors ({ commit, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: data.avanzar ? data.avanzar : false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: data.claveFin ? data.claveFin : '',
            claveInicio: data.claveInicio ? data.claveInicio : '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: 'N',
            oficina: '0001',
            pantPagina: '',
            retroceder: data.retroceder ? data.retroceder : false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codcom: data.codcom
          }
        }
      })
      commit('TARIFF_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.listadoVendedores, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            return response.data.runServiceResponse.return

          case 210:
            return false

          case 200:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  async addVendor ({ commit, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: storageAppData.canal,
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: 'N',
            oficina: '0001',
            pantPagina: '',
            retroceder: false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            apellvend: data.apellvends,
            clamon: '978',
            codcom: data.codcom,
            cpvend: data.cpvend,
            ctacargo: data.ctacargo,
            delegacion: data.delegacion,
            direven: data.direven,
            iban: data.iban,
            mailcomer: data.mailcomer,
            nomvend: data.nomvends,
            numdocv: data.numdocvs,
            poblvend: data.poblvend,
            provvend: 1,
            tipdocv: data.tipdocvs,
            tlfocomer: data.tlfocomer,
            estructura: '1',
            bloqven: 0,
            clamonp: 0,
            codgrup1: '1',
            codgrupo: '1',
            codproces1: '3',
            codproceso: '94',
            codvend: '',
            estvend: 'A',
            fecalta: data.fecalta,
            fecbaja: { anno: '', dia: '', mes: '', format: '', nombreDia: '', nombreMes: '', valueDate: '' },
            fecblqv: { anno: '', dia: '', mes: '', format: '', nombreDia: '', nombreMes: '', valueDate: '' },
            fecestad: { anno: '', dia: '', mes: '', format: '', nombreDia: '', nombreMes: '', valueDate: '' },
            impvtasfin: '0',
            motbaja: ''
          }
        }
      })
      commit('TARIFF_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.addVendor, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            if (Array.isArray(response.data.runServiceResponse.return.registros)) return response.data.runServiceResponse.return.registros
            else return [response.data.runServiceResponse.return.registros]

          case 210:
            return false

          case 200:
            return response.data.runServiceResponse.return.descRetorno

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  async modifyVendor ({ commit, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: storageAppData.canal,
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: 'N',
            oficina: '0001',
            pantPagina: '',
            retroceder: false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            apellvend: data.apellvends,
            bloqven: data.bloqven,
            clamon: data.clamon,
            clamonp: data.clamonp,
            codcom: data.codcom,
            codgrupo1: data.codgrupo1,
            codgrupo: data.codgrupo,
            codproces1: data.codproces1,
            codproceso: data.codproceso,
            codvend: data.codvends,
            contcur: data.contcur,
            cpvend: data.cpvend,
            ctacargo: data.ctacargo,
            delegacion: data.delegacion,
            direven: data.direven,
            estructura: data.estructura,
            estvend: data.estvend,
            fecalta: data.fecalta,
            fecbaja: data.fecbaja,
            fecblqv: data.fecblqv,
            fecestad: data.fecestad,
            iban: data.iban,
            impvtasfin: data.impvtasfin,
            mailcomer: data.mailcomer,
            nomvend: data.nomvends,
            numdocv: data.numdocvs,
            poblvend: data.poblvend,
            provvend: data.provvend,
            tipdocv: data.tipdocvs,
            tlfocomer: data.tlfocomer
          }
        }
      })
      commit('TARIFF_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.editVendor, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            if (Array.isArray(response.data.runServiceResponse.return.registros)) return response.data.runServiceResponse.return.registros
            else return [response.data.runServiceResponse.return.registros]

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
      commit('TARIFF_REQUEST_FINISHED', false)
      return response.data.runServiceResponse.return.registros
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  async deleteVendor ({ commit, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: storageAppData.canal,
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: 'N',
            oficina: '0001',
            pantPagina: '',
            retroceder: false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codvend: data.codvends,
            contcur: data.contcur,
            fecbaja: data.fecbaja,
            motbaja: '23'
          }
        }
      })

      const response = await HTTP.post(config.endpoints.deleteVendor, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            if (Array.isArray(response.data.runServiceResponse.return.registros)) return response.data.runServiceResponse.return.registros
            else return [response.data.runServiceResponse.return.registros]

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
      return false
    }
  },

  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  }
}

// mutations
const mutations = {
  'SET_LOADER' (state, actions) {
    state.loading = actions.loader === true
    state.isPasswordText = actions.password === true
  },
  'TARIFF_REQUEST_STARTED' (state, payload) {
    state.loading = payload
  },
  'TARIFF_REQUEST_FINISHED' (state, payload) {
    state.loading = payload
  },
  'TARIFF_REQUEST_SUCCEED' (state, payload) {
    const datos = payload
    state.error = false
    state.errorDescription = ''
    state.totalRegistros = datos.totalRegistros
    state.code = datos.totalRegistros > 1 ? datos.registros : Array(datos.registros)
  },
  'TARIFF_REQUEST_FAILED' (state, payload) {
    if (payload.retorno === 200) {
      state.errorDescription = 'Error ejecución de servicio'
    } else if (payload.retorno === 220) {
      state.errorDescription = 'Error técnico'
    } else if (payload.retorno === '039') {
      state.errorDescription = 'Sesión expirada'
    } else if (payload.retorno === 210) {
      state.errorDescription = 'No se encontraron datos para los criterios de selección'
    }
    state.error = true
    state.code = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
